import React from 'react';
import PERFORMANCE_RECOMMENDATIONS from '../../../../../modules/campaigns/modules/performance-recommendations/config/performanceRecommendations';
import { AudienceNotification } from '../AudienceNotification/AudienceNotification';

export const AttentiveAudienceNotification = ({ notification, timeDiffInMinutes, closeNotificationCenter }) => (
    <AudienceNotification
        timeDiffInMinutes={timeDiffInMinutes}
        notification={notification}
        closeNotificationCenter={closeNotificationCenter}
        notificationType={PERFORMANCE_RECOMMENDATIONS.ATTENTIVE_AUDIENCE}
    />
);
